/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const ExpandDiagonalLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M17.59 5H14V3h7v7h-2V6.41l-4.3 4.3-1.4-1.42zM3 14h2v3.59l4.3-4.3 1.4 1.42L6.42 19H10v2H3z" />
  </Icon>
);
